import {useMemo, useState} from 'react';
import styled from 'styled-components';
import {LoadingBar} from '@/components/LoadingBar';
import {Tooltip} from '@/components/Tooltip';
import {Typography} from '@/components/Typography';
import {useGA4WithParams} from '@/hooks/tracking';
import {useMapDataSource} from '@/map/api';
import {Flexbox} from '@/styled-components';
import {palette} from '@/styles';
import {GrayCenterBox, SectionBlock, SectionSubTitle, SectionTitle} from '../../StyledComponents';
import {StudentBarChart} from '../Chart/StudentBarChart';
import {EMPTY_ITEM_TYPES, STUDENT_TABS} from '../constants';
import {EmptyItem} from '../EmptyItem';
import {PopulationDataProps} from '../interface';

export const StudentsCompare = ({
  isPending,
  error,
  data: rawdata,
}: PopulationDataProps) => {
  const {data: dataSource} = useMapDataSource();
  const metadata = useMemo(
    () => dataSource?.find((source) => source.key === 'school'),
    [dataSource]
  );

  const data = useMemo(() => {
    return rawdata?.map((i) => i.students);
  }, [rawdata]);

  return (
    <Root>
      <div>
        <Flexbox>
          <SectionTitle>학생 수</SectionTitle>
          <Tooltip
            openOnClick
            closeEvents={{
              mouseout: false,
              blur: false,
              click: true,
            }}
            iconStyle={{marginLeft: 2}}
            content={`지역 내 위치한 교육기관별 재적학생 수로 지역 내 거주하는 학생 수와는 다른 정보입니다.`}
          />
        </Flexbox>
        <SectionSubTitle>{`${metadata?.source?.split(' ')[0] || '마이프차'}∙${
          metadata?.baseDate || ''
        }∙명`}</SectionSubTitle>
      </div>
      {isPending ? (
        <GrayCenterBox>
          <LoadingBar color={palette.textSecondary} />
        </GrayCenterBox>
      ) : error ? (
        <Typography variant="medium12" color={palette.textSecondary}>
          분석 실패
        </Typography>
      ) : !data ? (
        <EmptyItem type={EMPTY_ITEM_TYPES.Population} />
      ) : (
        <StudentBarChartBox items={data} />
      )}
    </Root>
  );
};

const StudentBarChartBox = ({items}: {items: any[]}) => {
  const tracking = useGA4WithParams();
  const [tab, setTab] = useState<number>(0);
  const compareList = items.map((_, idx) => `비교 상권 ${idx + 1}`);

  const onTabChange = (index: number) => {
    tracking('analysis_compare_student', {
      student_info: STUDENT_TABS[index],
    });
    setTab(index);
  };

  return (
    <StudentBarChart
      type="학생 수"
      data={items}
      compareList={compareList}
      tabIndex={tab}
      onTabChange={onTabChange}
    />
  );
};

const Root = styled(SectionBlock)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
